export const LINK_MOVEMENT_PAGE_NAVIGATE = 'linked-movement-page-navigate'